import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
import { Replay } from "@sentry/replay";
import { ExtraErrorData } from "@sentry/integrations";

/* Sentry */
const sentryIntegrations = [new BrowserTracing(), new ExtraErrorData()];
if (process.env.REACT_APP_NODE_ENV === "development")
  sentryIntegrations.push(
    new Sentry.Integrations.Breadcrumbs({ console: false }),
  );

if (process.env.REACT_APP_NODE_ENV === "production")
  sentryIntegrations.push(
    new Replay({
      maskAllText: false,
    }),
  );

Sentry.init({
  dsn:
    "https://94bf064f28ea49a2828ecfc26c19dd40@o4503937355415552.ingest.sentry.io/4503978130014208",
  integrations: sentryIntegrations,
  environment: process.env.REACT_APP_NODE_ENV,
  release: process.env.REACT_APP_SENTRY_RELEASE,
  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 0.25,
  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate: 0,
  // If the entire session is not sampled, use the below sample rate to sample
  // sessions when an error occurs.
  replaysOnErrorSampleRate: 1.0,
});

export default Sentry;
